import { render, staticRenderFns } from "./CollectEmptyDefaultLayout.vue?vue&type=template&id=01a244fa&scoped=true"
import script from "./CollectEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CollectEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a244fa",
  null
  
)

export default component.exports